// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {deleteFileFromCloud as deleteFileRepo} from '../../../product/shared/repositories';

export const deleteFile = fileToDelete =>
    async (dispatch, getState) => {

        const doesFileExist = getState().duplicatePinPlateRequest.duplicatePinPlate.file.some(item => item.fileName === fileToDelete.fileName && item.serialNumber === fileToDelete.serialNumber);

        if (doesFileExist) {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                await deleteFileRepo(fileToDelete);

                dispatch({
                    data: fileToDelete,
                    type: actions.DELETE_DUPLICATE_PIN_PLATE_FILE
                });

            } catch (error) {

            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        }

    };



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/action-creators/delete-file.js